import { useQuery } from "@tanstack/react-query";
import UserService from "../../../service/UserService";

const getBlogSetupRequest = async (userId, blogId) => {
  const response = await UserService.getBlogSetupRequest({ userId, blogId });
  return response;
};

export default function useGetSetupRequest({ userId, blogId }, options) {
  return useQuery({
    queryKey: ["blogSetup", userId, blogId], 
    queryFn: () => getBlogSetupRequest(userId, blogId), 
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: blogId !== undefined,
    ...options,
  });
}
